import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { getConfig } from '@/config/config.ts';

export type GetContactsParams = {
  search: string;
  fields: string[];
};

export type GetContactsResponse = ContactInfo[];

export type ContactInfo = {
  fullName: string;
  isActive: boolean;
  emails: ContactEmail[];
  phones: ContactPhone[];
  type: 'Person';
  employeeOfAccountId: string;
  ecId?: string; // Ajouté pour les cas où ecId est présent
  name: string;
  givenName: string;
  jobType: string; // "OTHER" | "ADVISORY" | "CHIEF FINANCIAL OFFICER",
  localizedJobType: string; // "AUTRES" | "DIRECTEUR FINANCIER",
  jobTitle: string;
  internalHrTeam?: string; // Ajouté pour les cas où internalHrTeam est présent
  igg?: string; // Ajouté pour les cas où igg est présent
  id: string;
};

export type ContactEmail = {
  value: string;
  type: 'Professional' | 'Personal';
};

export type ContactPhone = {
  value: string;
  type: 'Business' | 'Mobile' | 'Business Fax';
  countryCodeIso2: string;
};

const CONTACTS_API_URL = new URL('contacts', getConfig().app.contactsApiUrl);

export const getContacts = (builder: WebapiEndpointBuilder) => {
  return builder.query<GetContactsResponse, GetContactsParams>({
    query: (params) => {
      return {
        url: `${CONTACTS_API_URL}`,
        params,
        method: 'GET',
      };
    },
  });
};
